<template>
  <div class="col-xs-12 p-24">
    <div
      class="heading separator d-flex align-items-center xs-flex-start pr-8 xs-flex-column justify-space-between"
    >
      <span class="word-break text-emergo-dark-blue">
        {{ globalSearchInfo.total_search_result_count || 0 }} Result(s) for ‘{{ searchTerm }}’
      </span>
      <button @click="navigateToDashboard" class="emergo-white-button xs-flex-100">
        Exit Search
      </button>
    </div>
    <div class="col-lg-12 p-0" id="searchResultAccordian">
      <div class="col-xs-12 p-0 p-relative filter-wrapper">
        <shared-left-filter
          @setFilter="filteredOptions"
          :chevronList="chevronList"
          :expectedFilter="resultingFilter"
          :countriesList="countryListFilter"
          :servicesList="servicesList"
          :isCountryString="true"
          :types="types"
          :hideServicesForGlobalSearch="isSingleService"
        >
        </shared-left-filter>
      </div>
      <div class="col-xs-12 p-0 list-wrapper accordion acc-pl">
        <div
          class="panel search-panel wrapper-panel"
          v-for="(record, index) in filteredServices"
          :key="index"
        >
          <div
            role="button"
            data-toggle="collapse"
            :data-target="'#collapse' + index"
            aria-expanded="true"
            :aria-controls="'collapse' + index"
            class="panel_title font-18 fw-400 text-secondary"
            :class="{ collapsed: record.service_name !== selectedServiceName }"
            data-parent="#searchResultAccordian"
          >
            {{
              `${record.result_count} Result(s) for '${searchTerm}' found in ${record.service_name}`
            }}
          </div>
          <div
            :id="'collapse' + index"
            data-parent="#searchResultAccordian"
            class="panel-collapse collapse mt-14 result-list"
            :class="{ in: record.service_name === selectedServiceName }"
            role="tabpanel"
            aria-labelledby="searchResults"
          >
            <div class="panel-body" v-for="(ele, index) in record.service_results" :key="ele.id">
              <div
                class="card cursor-pointer"
                @click="navigateToRespectivePage(record.service_name, ele)"
              >
                <services :serviceName="record.service_name" :recordInfo="ele"></services>
              </div>
              <div
                v-if="index === 4"
                class="see-more text-emergo-dark-blue font-18 fw-400 cursor-pointer col-xs-12 p-0 d-flex justify-content-end"
                @click="navigateToServiceSearch(record.service_name)"
              >
                View All
              </div>
            </div>
          </div>

          <div class="separator results"></div>
        </div>
      </div>
    </div>
    <unsubscribed-country-popup
      id="modal_unsubscribed_market"
      :isGlobalSearch="true"
      :selectedServiceId="selectedServiceId"
    ></unsubscribed-country-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import Loader from '../../UIComponents/Loader.vue';
import UnsubscribedCountryPopup from '../../RegulatoryProcessCharts/UnsubscribedCountryPopup.vue';
import globalSearch from '../../../apis/globalSearch';
import Services from './Services.vue';
import SharedLeftFilter from '../../UIComponents/SharedLeftFilter.vue';
import { GLOBAL_SEARCH_CATEGORIES, GLOBALSEARCH_MAPPING } from './constants';
import globalSearchMixin from './mixins';

export default {
  mixins: [globalSearchMixin],
  data() {
    return {
      isSingleService: false,
      chevronList: {
        isCountryChevron: 'Country'
      },
      selectedFilterOptions: {},
      resultingFilter: {
        countriesList: [],
        servicesRegistered: [],
        isFilterSelected: false
      },
      types: {
        countryId: 'country_name',
        countryName: 'country_name',
        label: 'global_search'
      },
      countryListFilter: [],
      searchCategories: GLOBAL_SEARCH_CATEGORIES,
      loaderStatus: false,
      selectedServiceName: '',
      searchTerm: '',
      globalSearchInfo: {},
      filteredServices: [],
      servicesWithIdAsIdentifier: {},
      activeServicesWithIdAsIdentifier: {},
      servicesList: [],
      isGeneralizedCountriesList: false,
      selectedServiceId: null
    };
  },

  components: {
    Loader,
    Services,
    SharedLeftFilter,
    UnsubscribedCountryPopup
  },

  methods: {
    async filteredOptions(filter) {
      this.loaderStatus = true;
      this.selectedFilterOptions = cloneDeep(filter);
      await this.getListBySearch();
      this.loaderStatus = false;
    },
    navigateToDashboard() {
      this.$router.push('/layout/dashboard');
    },
    navigateToServiceSearch(serviceName) {
      const query = { ...this.$route.query, service: serviceName };
      this.$router.push({ name: 'SearchByService', query });
    },
    /**
     * On click of card navigate to the corresponding service if srvice is activated.
     * Regulations & Guidance is a free service
     * @param {string} service
     * @param {object} record
     */
    navigateToRespectivePage(service, record) {
      const serviceName = GLOBALSEARCH_MAPPING[service];
      this.selectedServiceId = this.servicesWithIdAsIdentifier[serviceName];
      this.navigateIfServiceHasAccess(serviceName, service, record);
    },
    async getListBySearch() {
      this.loaderStatus = true;
      const { servicesRegistered } = this.selectedFilterOptions;
      const request = {
        page_size: 5,
        paze_number: 0,
        search_value: this.searchTerm,
        countries: this.selectedFilterOptions.countriesList || []
      };
      const services = [];
      if (servicesRegistered?.length) {
        servicesRegistered.forEach((element) => {
          services.push(element);
        });
        request.services = services;
      }
      if (this.isSingleService && !servicesRegistered?.length) {
        request.services = request.services
          ? [...request.services, this.selectedServiceName]
          : [this.selectedServiceName];
      }
      this.globalSearchInfo = await globalSearch(request);
      if (this.isGeneralizedCountriesList) {
        this.countryListFilter = this.globalSearchInfo.all_countries;
        this.isGeneralizedCountriesList = false;
      }
      this.filteredServices = this.globalSearchInfo.results.filter(
        (service) => service.result_count
      );
      this.loaderStatus = false;
    },
    /**
     * Set search term, selected service and then fetch the results
     * @param {String} searchTerm
     * @param {String} service
     */
    async setSearchValueAndGetList(searchTerm, service) {
      this.searchTerm = searchTerm;
      this.selectedServiceName = service;
      await this.getListBySearch();
    }
  },
  /**
   * setServices is a part of global search mixin which is used in couple of components
   */
  async created() {
    this.loaderStatus = true;
    const { service, searchTerm } = this.$route.query;
    if (!service || !searchTerm) this.$router.push('/layout/dashboard');
    this.isSingleService = service !== 'all';
    this.isGeneralizedCountriesList = true;
    await this.setServices(true);
    await this.setSearchValueAndGetList(searchTerm, service, true);
    this.loaderStatus = false;
  },
  watch: {
    async $route(to) {
      const { service, searchTerm } = to.query;
      if (!service || !searchTerm) this.$router.push('/layout/dashboard');
      else {
        this.isGeneralizedCountriesList = true;
        this.isSingleService = service !== 'all';
        this.loaderStatus = true;
        this.resultingFilter = {
          countriesList: [],
          servicesRegistered: [],
          isFilterSelected: false
        };
        this.selectedFilterOptions = {};
        this.selectedServiceName = '';
        this.selectedFilterOptions.servicesRegistered = [];
        await this.setSearchValueAndGetList(searchTerm, service);
        await this.setServices(true);
        if (this.isSingleService) {
          this.servicesList = [];
        }
        this.loaderStatus = false;
      }
    }
  }
};
</script>

<style scoped>
.heading.separator {
  padding-bottom: 22px;
  border-bottom: 0.7px solid #bdbdbd;
}

.mt-14 {
  margin-top: 14px;
}

.see-more {
  margin: 35px 0px;
}

.heading span {
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
}

.collapse.in {
  height: auto !important;
}

#searchResultAccordian .panel-body {
  padding: 0;
  margin: -1px;
}

.card {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px 32px;
  margin-bottom: 16px;
  box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.27);
}

.result-list {
  padding-right: 68px;
}

.panel_title {
  width: 100%;
  font-size: 22px;
  line-height: 26px;
  padding: 20px 68px 20px 0px;
}

.panel {
  margin-bottom: 0px;
  border-bottom: 0.7px solid #bdbdbd;
}

.panel_title.collapsed:after {
  content: '\e6e0';
  font-family: 'element-icons';
  display: block;
  transform: rotate(0deg);
  color: #0b3c61;
  font-weight: bolder;
}

.panel_title:after {
  content: '\e6e0';
  font-family: 'element-icons';
  float: right;
  display: block;
  transform: rotate(270deg);
  color: #0b3c61;
  font-weight: bolder;
}

.p-24 {
  padding: 24px;
}

.list-wrapper {
  padding: 0px 0px 0px 76px;
}

.filter-wrapper {
  position: absolute;
  left: -24px;
  top: -3px;
}

@media screen and (max-width: 767px) {
  .xs-flex-column {
    flex-direction: column;
    row-gap: 20px;
  }

  .panel_title {
    padding-right: 30px;
  }
  .list-wrapper {
    padding-left: 0px;
  }

  .result-list {
    padding-right: 0px;
  }
  .xs-flex-start {
    align-items: flex-start;
  }

  .xs-flex-100 {
    width: 100%;
  }
}
</style>
